import React, { createContext, useReducer, useContext } from 'react';
import { validFormData, validContact, getTotalPrice } from './service';

const RootStateContext = createContext();
const RootDispatchContext = createContext();

const initCreateTournamentState = {
  pluginsPrice: null,
  formData: {
    title: '',
    type: 'CUP_MATCHES',
    team_type: 'NONE',
    player_type: 'NONE',
    ball_type: 'ORDINARY',
    bat_type: 'NONE',
    start_at: '',
    end_at: '',
    auto_game_seq: false,
    locations: [],
  },
  plugins: {
    open_registration: true,
    expand_media_space: false,
    paper_record_online: false,
    offline_commissioner: false,
  },
  contact: {
    name: '',
    phone: '',
    lineID: '',
  },
  creatable: false,
  isFree: false,
  apiLoading: false,
  inPlanCheck: false,
};

const createTournamentReducer = (state, action) => {
  const getCreatable = (isFree, formValid, contactValid) => {
    if (isFree || !state.inPlanCheck) {
      return formValid;
    }

    return formValid && contactValid;
  };

  const { type, payload } = action;
  switch (type) {
    case 'UPDATE_FORM': {
      const formValid = validFormData(payload, false);
      const contactValid = validContact(state.contact, false);
      return {
        ...state,
        formData: payload,
        creatable: getCreatable(state.isFree, formValid, contactValid),
      };
    }
    case 'UPDATE_PLUGIN': {
      const newPlugins = {
        ...state.plugins,
        [payload]: !state.plugins[payload],
      };
      const isFree = getTotalPrice(state.pluginsPrice, newPlugins) === 0.0;
      const formValid = validFormData(state.formData, false);
      const contactValid = validContact(state.contact, false);
      return {
        ...state,
        plugins: { ...newPlugins },
        isFree,
        creatable: getCreatable(isFree, formValid, contactValid),
      };
    }
    case 'UPDATE_PLUGINS_PRICE': {
      return { ...state, pluginsPrice: payload };
    }
    case 'SET_PLAN_CHECK': {
      const formValid = validFormData(state.formData, false);
      const contactValid = validContact(state.contact, false);
      return {
        ...state,
        inPlanCheck: payload,
        creatable: state.isFree || !payload ? formValid : formValid && contactValid,
      };
    }
    case 'UPDATE_CONTACT': {
      const formValid = validFormData(state.formData, false);
      const contactValid = validContact(payload, false);
      return { ...state, contact: payload, creatable: getCreatable(state.isFree, formValid, contactValid) };
    }
    case 'UPDATE_API_STATUS': {
      return { ...state, apiLoading: payload };
    }
    default:
      throw new Error('Invalid action type');
  }
};

const CreateTournamentProvider = ({ children }) => {
  const [state, dispatch] = useReducer(createTournamentReducer, initCreateTournamentState);

  return (
    <RootStateContext.Provider value={state}>
      <RootDispatchContext.Provider value={dispatch}>{children}</RootDispatchContext.Provider>
    </RootStateContext.Provider>
  );
};

const useCreateTournamentState = () => {
  const context = useContext(RootStateContext);

  if (context === undefined) {
    throw new Error('useCreateTournamentState must be used within a CreateTournamentProvider');
  }
  return context;
};

const useCreateTournamentDispatch = () => {
  const context = useContext(RootDispatchContext);

  if (context === undefined) {
    throw new Error('useCreateTournamentDispatch must be used within a CreateTournamentProvider');
  }
  return context;
};

export { CreateTournamentProvider, useCreateTournamentState, useCreateTournamentDispatch };
